'use client';

import VideoPlayer from 'components/media/VideoPlayer';
import { ComponentFields } from 'types/content';
import parse from 'html-react-parser';

import { selectVideoSource } from 'utils/mediaUtils';

const ExplanationComponent = ({ data, onContinue }: ComponentFields) => {
  const continueText = data.elements.continue_text?.value || 'Continue';
  const placeholderBody = data.elements.placeholder_body?.value || '';
  const video = data.elements.video?.value;

  return (
    <div
      className={`explanation-page${
        video ? ' explanation-page--with-video' : ''
      }`}
    >
      {video && (
        <VideoPlayer
          dynamicText={video.dynamicText?.url}
          key={selectVideoSource(video)}
          source={selectVideoSource(video)}
          stillImage={video.videoStillImage?.url}
          track={video.closedCaption?.url}
          transcript={video.videoTranscript}
          onContinue={onContinue}
        />
      )}
      {!video && (
        <div className="explanation-page-content">
          {placeholderBody && parse(placeholderBody)}
          <button
            className="button primary full-width"
            onClick={onContinue}
            data-testid="explanation-continue-button"
          >
            {continueText}
          </button>
        </div>
      )}
    </div>
  );
};

export default ExplanationComponent;
